(() => {
  const caps = {"44711260880989":4,"44711260913757":4,"44711260946525":4,"44711260979293":4,"44711261077597":2,"44711261110365":2,"44711261143133":2,"44711261175901":2,"44711263961181":2,"44711263993949":2,"44711264026717":2,"44711264059485":2};
  const pending = new WeakMap();
  const text = 'PRE-ORDER — Estimated to ship by Sep 25';
  let queued = false;
  function selectedId(node) {
    const card = node.closest('.product-item');
    if (card) {
      const link = card.querySelector('a.card-title, a[data-product-url]');
      const value = link && new URL(link.href, location.origin).searchParams.get('variant');
      return value || node.dataset.preorderVariant;
    }
    const view = node.closest('.productView');
    const form = node.closest('form') || (view && view.querySelector('form[data-type="add-to-cart-form"]')) || document.getElementById('product-form-' + node.dataset.preorderProduct);
    return form?.querySelector('[name="id"]')?.value || node.dataset.preorderVariant;
  }
  function sync() {
    queued = false;
    document.querySelectorAll('[data-zhizhi-preorder-form], [data-zhizhi-preorder-badge]').forEach(node => {
      const id = selectedId(node);
      const active = !!caps[id];
      if (node.hidden === active) node.hidden = !active;
      const view = node.closest('.productView');
      if (node.hasAttribute('data-zhizhi-preorder-form') && view) {
        if (view.classList.contains('zhizhi-is-preorder') !== active) view.classList.toggle('zhizhi-is-preorder', active);
        const form = node.closest('form');
        const button = form?.querySelector('[type="submit"][name="add"]');
        if (button && !button.disabled && !button.classList.contains('loading')) {
          if (active && button.textContent.trim() !== 'PRE-ORDER') {
            pending.set(button, button.innerHTML);
            button.textContent = 'PRE-ORDER';
          } else if (!active && pending.has(button)) {
            if (button.textContent.trim() === 'PRE-ORDER') button.innerHTML = pending.get(button);
            pending.delete(button);
          }
        }
        const property = form?.querySelector('[data-zhizhi-preorder-property]');
        if (property && property.disabled === active) property.disabled = !active;
      }
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  new MutationObserver(schedule).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['value','href','disabled']});
  document.addEventListener('change', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();
